import { NgModule } from '@angular/core';
import {
  CircularProgressModule,
  CIRCULAR_PROGRESS_DEFAULT_OPTIONS,
} from '../circular-progress';
import { LoadingOverlayComponent } from './loading-overlay.component';

@NgModule({
  imports: [CircularProgressModule],
  declarations: [LoadingOverlayComponent],
  exports: [LoadingOverlayComponent],
  providers: [
    {
      provide: CIRCULAR_PROGRESS_DEFAULT_OPTIONS,
      useValue: { color: 'white' },
    },
  ],
})
export class LoadingOverlayModule {}
